import { IAdGroupCategoryOptional } from '@unfoldrtech/portal-mic'

export function transformCategoryTarget(catTarget: IAdGroupCategoryOptional) {
  return {
    id: catTarget.id,
    bidPrice: Number(catTarget.bidPrice),
  }
}
